module.exports = __webpack_public_path__ + "static/media/watch.abac8ea7.svg";